// export const api = 'http://192.168.30.56:8080'
// export const api = 'http://192.168.40.48:3100'
// export const api = 'http://192.168.30.11:3100'
// export const api = 'http://192.168.30.2:8500'
// export const api = 'http://accounting-api.laodeveloper.com'
// export const api = 'https://api-accounting.soliserp.com'
// export const api = 'https://api.phongsavanhgroup.com'
export const api = 'https://crs-endpoint.crslao.com'